var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 8,
    fill: "#E9E9E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3163_703",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 65
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 8,
    fill: "#E9E9E8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3163_703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3429 25.6154C18.3429 17.5569 24.9185 11 33 11C41.0815 11 47.6571 17.5569 47.6571 25.6154C47.6571 33.6738 41.0815 40.2308 33 40.2308C24.9185 40.2308 18.3429 33.6738 18.3429 25.6154ZM42.2571 44.8462H23.7429C13.9611 44.8462 6 52.7846 6 62.5385C6 67.2062 9.80469 71 14.4857 71H51.5143C56.1953 71 60 67.2062 60 62.5385C60 52.7846 52.0389 44.8462 42.2571 44.8462Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/default_profile.7b6815e90df3f79f06afff4e50df61c2.svg";
export { ForwardRef as ReactComponent };